"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchConversationMaybe = exports.removeDriftProtocol = void 0;
var removeDriftProtocol = function removeDriftProtocol(url) {
  return url.substr(8);
};
exports.removeDriftProtocol = removeDriftProtocol;
var fetchConversationMaybe = function fetchConversationMaybe(url) {
  if (!url.includes("/conversations")) {
    return undefined;
  }
  return url.substring(url.indexOf('/conversations'));
};
exports.fetchConversationMaybe = fetchConversationMaybe;